var render = function render(_c,_vm){return _c('div',{staticClass:"modal-body"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }